import React from "react";
import multiLang from "../../lang/lang.json";
import withStyles from "@material-ui/core/styles/withStyles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import CustomDropdown from "../CustomDropdown/CustomDropdown";
import { Apps } from "@material-ui/icons";
import Link from "@material-ui/core/Link";
import Grid from "@material-ui/core/Grid";

import Button from "../CustomButtons/Button";

import headerLinksStyle from "./headerLinksStyle";
import { Hidden } from "@material-ui/core";

const HeaderLinks = ({ ...props }) => {
  const { classes, categories, lang } = props;
  const departs = [
    "Art Gallery",
    "Investment",
    "Exchange",
    "Education & Learning",
    "Game Center",
    "Sports betting / bet & Gamble / Casino",
    "Web Services & Digital Marketing",
    "Business Assistant",
    "Coffee Music",
    "Coffee Cinema",
    "IPTV",
    "Payments",
    "Hyper Market",
    "Garment and Fashion",
    "Food & Restaurants",
    "Travel agency",
    "itaxi",
    "Discount services",
    "Car Market",
    "Car Rent",
    "Rental of garden and villa",
    "Real Estate",
    "Insurance",
    "Book Store",
    "C2C Marketplace",
    "Employment",
    "Home Services",
    "B2B Marketplace",
    "Smart City & Smart Home",
    "Virtual Reality & Argument Reality",
    "Online Projects & Freelancers",
    "Scientific and Student Services",
    "Foreign payments and purchases",
    "Advertising",
    "App & License Market",
    "Business Services",
    "Celebrations and Ceremonies",
    "Roommate",
    "Matching",
    "Databases",
    "Flowers and Gifts",
    "E-City"
  ];
  const departsfa = [
    "هنر و صنایع دستی",
    "فروش سهام و جذب سرمایه ) ICO )",
    "صرافی آنلاین",
    "آموزش آنلاین",
    "بازی های آنلاین",
    "پیش بینی ورزشی و شرط بندی",
    "خدمات حوزه وب و دیجیتال مارکتینگ",
    "پکیج تبلیغات دیجیتال برای بهبود فروش کسب و کارهای کوچک و سنتی",
    "کافه موسیقی",
    "کافه سینما",
    "IPTV",
    "خدمات پولی و مالی ، پرداخت ها ، شارژها / دفتر خدمات الکترونیک عمومی",
    "فروشگاه اینترنتی",
    "مد و پوشاک",
    "غذا و رستوران",
    "آژانس خدمات مسافرتی",
    "تاکسی یاب اینترنتی",
    "کارتهای تخفیف و تخفیف های گروهی",
    "خرید و فروش خودرو",
    "اجاره خودرو",
    "اجاره باغ و ویلا",
    "آزانس املاک",
    "فروش بیمه",
    "فروشگاه کتاب",
    "خرید و فروش وسایل دست دوم",
    "کاریابی",
    "مرکز خدمات منزل",
    "خرید و فروش های عمده و صنعتی B2B",
    "اینترنت اشیا و شهر هوشمند",
    "واقعیت مجازی و واقعیت افزوده",
    "پروژه های آنلاین",
    "خدمات علمی و دانشجویی",
    "پرداخت ها و خرید های خارجی",
    "تبلیغات رسانه ای ، تبلیغات محیطی ، چاپ ، هدایای تبلیغاتی",
    "اپلیکیشن موبایل، لایسنس نرم افزار و آنتی ویروس",
    "خدمات حوزه کسب و کار",
    "جشن ها و تشریفات",
    "هم خونه ای و اجاره سوئیت",
    "همسان گزینی",
    "بانک های اطلاعاتی",
    "ارسال گل و هدیه",
    "ارائه خدمات فنی و مهندسی مربوط به شهر الکترونیک"
  ];
  return (
    <List className={classes.list}>
      <Hidden smDown implementation={"css"}>
        <div style={{ float: "right" }}>
          <ListItem className={classes.listItem}>
            <CustomDropdown
              rtlActive={lang === "en" ? false : true}
              noLiPadding
              buttonText={multiLang["052"][lang]}
              buttonProps={{
                className: classes.navLink,
                color: "transparent"
              }}
              buttonIcon={Apps}
              dropdownList={
                lang === "en"
                  ? departs.map((dep, i) => {
                      if (dep === "Art Gallery") {
                        return (
                          <Link
                            key={i}
                            href={"/"}
                            className={classes.dropdownLink}
                          >
                            <Grid item md={4}>
                              {dep}
                            </Grid>
                          </Link>
                        );
                      } else {
                        return (
                          <Link
                            key={i}
                            className={classes.dropdownLinkDisabled}
                          >
                            {dep}
                          </Link>
                        );
                      }
                    })
                  : departsfa.map((dep, i) => {
                      if (dep === "هنر و صنایع دستی") {
                        return (
                          <Link
                            key={i}
                            href={"/"}
                            className={classes.dropdownLink}
                          >
                            <Grid item md={4}>
                              {dep}
                            </Grid>
                          </Link>
                        );
                      } else {
                        return (
                          <Link
                            key={i}
                            className={classes.dropdownLinkDisabled}
                          >
                            {dep}
                          </Link>
                        );
                      }
                    })
              }
              type="organization"
              mobile={false}
              lang={lang}
            />
          </ListItem>
        </div>
        <div>
          <ListItem className={classes.listItem}>
            <CustomDropdown
              noLiPadding
              buttonText={multiLang["014"][lang]}
              buttonProps={{
                className: classes.navLink,
                color: "transparent"
              }}
              buttonIcon={Apps}
              dropdownList={
                categories !== null &&
                categories.map((category, i) => (
                  <Link
                    key={i}
                    href={`/search?c=${category.id}`}
                    className={classes.dropdownLink}
                  >
                    {category.name}
                  </Link>
                ))
              }
            />
          </ListItem>
        </div>
      </Hidden>
      <Hidden smUp implementation={"js"}>
        <ListItem className={classes.listItem}>
          <CustomDropdown
            noLiPadding
            buttonText={multiLang["052"][lang]}
            buttonProps={{
              className: classes.navLink,
              color: "transparent"
            }}
            buttonIcon={Apps}
            dropdownList={
              lang === "en"
                ? departs.map((dep, i) => {
                    if (dep === "Art Gallery") {
                      return (
                        <Link
                          key={i}
                          href={"/"}
                          className={classes.dropdownLink}
                        >
                          <Grid item md={4}>
                            {dep}
                          </Grid>
                        </Link>
                      );
                    } else {
                      return (
                        <Link key={i} className={classes.dropdownLinkDisabled}>
                          {dep}
                        </Link>
                      );
                    }
                  })
                : departsfa.map((dep, i) => {
                    if (dep === "هنر و صنایع دستی") {
                      return (
                        <Link
                          key={i}
                          href={"/"}
                          className={classes.dropdownLink}
                        >
                          <Grid item md={4}>
                            {dep}
                          </Grid>
                        </Link>
                      );
                    } else {
                      return (
                        <Link key={i} className={classes.dropdownLinkDisabled}>
                          {dep}
                        </Link>
                      );
                    }
                  })
            }
          />
        </ListItem>
        <ListItem className={classes.listItem}>
          <CustomDropdown
            noLiPadding
            buttonText={multiLang["014"][lang]}
            buttonProps={{
              className: classes.navLink,
              color: "transparent"
            }}
            buttonIcon={Apps}
            dropdownList={
              categories !== null &&
              categories.map((category, i) => (
                <Link
                  key={i}
                  href={`/search?c=${category.id}`}
                  className={classes.dropdownLink}
                >
                  {category.name}
                </Link>
              ))
            }
          />
        </ListItem>
        <ListItem className={classes.listItem}>
          <Button href="/" color="transparent" className={classes.navLink}>
            {multiLang["015"][lang]}
          </Button>
        </ListItem>
        <ListItem className={classes.listItem}>
          <Button href="/" color="transparent" className={classes.navLink}>
            {multiLang["016"][lang]}
          </Button>
        </ListItem>
        <ListItem className={classes.listItem}>
          <Button href="/about" color="transparent" className={classes.navLink}>
            {multiLang["053"][lang]}
          </Button>
        </ListItem>
      </Hidden>
    </List>
  );
};

export default withStyles(headerLinksStyle)(HeaderLinks);
